// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__8ww4R","link":"Footer_link__TB6l8"};